import { Score } from "src/app/service/global.service"


export class ScoreController{

    /**
     * Return the list where the score is
     * 
     * @param score 
     * @returns string
     */
    typeOfPreventional(score:Score | undefined){
        if(score?.blacklistsTriggered && score?.blacklistsTriggered.length>0){
          return "blacklist"
        }
        if(score?.whitelistsTriggered && score?.whitelistsTriggered.length>0 ){
          return "whitelist"
        }
        if((this.getGreylist(score).length>0 && (!score?.whitelistsTriggered || score?.whitelistsTriggered?.length==0)) || (this.getGreylist(score).length>0 && (!score?.blacklistsTriggered || score?.blacklistsTriggered?.length==0))){
          return "greylist"
        }
        else return "default"
    }

    /**
     * Return all names of graylist the score is
     * 
     * @param score 
     * @returns string[] List
     */
    getGreylist(score: Score | undefined) {
      return score?.greylistsTriggered?.filter(gr => gr.belongs) || [];
    }

    formatScore(score:number|undefined){
        if(score){
          return score*100
        }else return 0
    }

    /**
     * 
     * @param score 
     * 
     * Return families of string where their own score isn't normal (< 100%)
     */
    getSubScoreBreak(score: Score | undefined) {
      const breakKey: any[] = [];
      Object.entries(score?.subscoresPrevention || {}).forEach(([k, v]) => {
        if (typeof v === 'number' && v < 1.0) {
          breakKey.push([k, v * 100]);
        }
      });
      return breakKey;
    }

    formatScoreFamily(score:string){
        let s=score.replace('score','')
        if(s=='Bw'){
          s='black&White'
        }
        return s
    }

    /**
     * Return the status of a score according to his value. It's use for stylesheet
     * 
     * @param score 
     * @returns string
     */
    statutFamilyScorePrevention(score: number) {
        let statut = "probe-ok"
        if(score<80){
          statut="probe-warning"
        }
        if(score<50){
          statut="probe-fatal"
        }
        if(score==undefined){
            statut="probe-undefined"
        }
        return statut
    }
}